import * as commonActions from './commonActions';
import companyApi from '../api/companyApi';


export function loadCompanies() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return companyApi.loadCompanies(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadCompany(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return companyApi.loadCompany(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveCompany(company) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return companyApi.saveCompany(getState().authenticationState.token, company).then(savedCompany => {
            dispatch(commonActions.unlockScreen());
            dispatch(commonActions.loadConfiguration());
            return savedCompany;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteCompany(companyId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return companyApi.deleteCompany(getState().authenticationState.token, companyId).then(() => {
            dispatch(commonActions.loadConfiguration());
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}
